// extracted by mini-css-extract-plugin
export default {"wrapper":"Skeleton_wrapper__GXLXQ","loading":"Skeleton_loading__36I1T"};